var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDependabilityIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88379 9.41551H2.35109C1.05469 9.41551 0 10.4702 0 11.7666V14.1201C0 15.4165 1.05469 16.4712 2.35109 16.4712H3.1891L2.52516 17.1352L3.35379 17.9638L5.43231 15.8853L3.35379 13.8068L2.52516 14.6354L3.1891 15.2994H2.35109C1.70086 15.2993 1.17188 14.7703 1.17188 14.1201V11.7666C1.17188 11.1164 1.70086 10.5874 2.35109 10.5874H5.88383V12.3525H14.1163V7.65039H5.88383V9.41551H5.88379ZM7.05566 8.82227H12.9443V11.1807H7.05566V8.82227Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88281 18.2354H14.1152V13.5332H5.88281V18.2354ZM7.05469 14.7051H12.9434V17.0635H7.05469V14.7051Z",
    fill: "#2667B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.648 3.53078H14.1152V1.76562H5.88281V6.46777H14.1152V4.70262H17.648C18.2982 4.70262 18.8272 5.2316 18.8272 5.88184V8.23539C18.8272 8.88559 18.2982 9.41457 17.648 9.41457H16.81L17.4739 8.75063L16.6453 7.92199L14.5668 10.0005L16.6453 12.079L17.4739 11.2504L16.81 10.5864H17.648C18.9444 10.5864 19.9991 9.53176 19.9991 8.23539V5.88184C19.9991 4.58547 18.9444 3.53078 17.648 3.53078ZM12.9434 5.2959H7.05473V2.9375H12.9434V5.2959Z",
    fill: "#2667B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependabilityIconBlue);
export default __webpack_public_path__ + "static/media/dependability_icon_blue.dc6fd0348cd221c06a9625ac45bb6fbd.svg";
export { ForwardRef as ReactComponent };